import React, { Component } from 'react';
import {connect} from 'react-redux';
import history from '../../../../history';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG,URL_AKM } from '../../../../config';
import akmApi from '../../../../apis/akmApi';
import accountManagement from '../../../../apis/accountManagement';
import {Col} from 'react-bootstrap';
import {TableContainer,Paper} from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

class PreviewSoal extends Component {
    constructor(props) {
        super(props);
        this.state = {      
            listSoal:[], 
            listDetailSoal: [], 
            profil: {},   
            subProfil: {},       
            isFetching: false,
        }
    }
    async componentDidMount() {        
        this.setState({ isFetching: true });          
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)){
           
            console.log(this.props.location.state)
            if(this.props.location.state != undefined) { 
                const profil = this.props.location.state.profil, 
                    subProfil = this.props.location.state.subProfil;
                this.setState({ profil: profil, subProfil: subProfil})
                this.fetchExamSoal(subProfil.idSubProfilCbt);
            }
        }

        
        this.setState({ isFetching: false });       
    }

    fetchSoalDetail = async(idBankSoal) => {
        //this.setState({ listDetailSoal: [] });     
        const result = await akmApi.get(URL_AKM.GET_SOAL_DETAIL_AKM_BY_IDBANKSOAL + idBankSoal)
            .catch(function(error){
                console.log(error)
            });
        
        if (result) { 
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){ 
                let listDetailSoal = this.state.listDetailSoal;
                //listDetailSoal.concat(result.data.data);
                //console.log(listDetailSoal)
                this.setState({ listDetailSoal: [...listDetailSoal, ...result.data.data] });          
            }
        }
    }

    fetchExamSoal = async(id) => {
        this.setState({ isFetching: true, listSoal:[] });
        const result = await accountManagement.get(CONFIG.EXAM_SOAL_GET + id)
            .catch(function(error){
                console.log(error)
            });
        
        if (result) { 
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){  
                let arraySoal = result.data.data.map(data => {                   
                    if(data.tipeSoal === 'BNS' || data.tipeSoal === 'DRAG') {                        
                        this.fetchSoalDetail(data.idBankSoal);       
                    }
                    return {...data}
                });
                this.setState({ listSoal: arraySoal });
            }
            this.setState({ isFetching: false });
        }
        (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "/vendor/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML";
        
            var config = 'MathJax.Hub.Config({' +
                'extensions: ["tex2jax.js"],' +
                'jax: ["input/TeX","output/HTML-CSS"]' +
                '});' +
                'MathJax.Hub.Startup.onload();';
        
            if (window.opera) {
                script.innerHTML = config
            } else {
                script.text = config
            }
        
            script.addEventListener('load', function() {
                if (window.MathJax && window.MathJax.Hub) window.MathJax.Hub.Queue(["Typeset",window.MathJax.Hub], "");
            })
        
            document.getElementsByTagName("head")[0].appendChild(script);
        })();           
    }

    renderSoalDrag(idbankSoal) {
        const array = this.state.listDetailSoal.filter(item => item.idBankSoal === idbankSoal);
        const output = [...new Map(array.map(o => [o.teori, o])).values()];
        console.log(output)
        return(
            <React.Fragment>
            {output.map((teori, i) => 
            <tr key={i}>
                <td>{array.filter(o => o.kunciJawaban === '1' && o.teori === teori.teori).map((detail,idx) => 
                    <tr key={idx}><p>{detail.pernyataan}</p></tr>
                    )}
                </td>
                <td>{array.filter(o => o.kunciJawaban === '0' && o.teori === teori.teori).map((detail,idx) => 
                    <tr key={idx}><p>{detail.pernyataan}</p></tr>
                    )}
                </td>
                <td><p>{teori.teori}</p></td>
            </tr>
            )}
            </React.Fragment>
        )
    }

    renderSoal() {      
        //console.log('list', this.state.listSoal)  
        //console.log('details', this.state.listDetailSoal)       
        return (
            <React.Fragment>
              {this.state.listSoal.map((soal,i) => 
                <tr key={i}>
                    <td><p>{soal.idBankSoal}</p></td>
                    <td>
                        <tr>Tipe Soal : {soal.tipeSoal}</tr>
                        <tr>
                            <span dangerouslySetInnerHTML={{__html: soal.pertanyaan}}></span>
                            
                        </tr>
                        <table className="table table-borderless">
                            <tbody>
                                {soal.jawab1 !== null && <tr><td width="5">A.</td><td dangerouslySetInnerHTML={{__html: soal.jawab1}}></td></tr>}
                                {soal.jawab2 !== null && <tr><td width="5">B.</td><td dangerouslySetInnerHTML={{__html: soal.jawab2}}></td></tr>}
                                {soal.jawab3 !== null && <tr><td width="5">C.</td><td dangerouslySetInnerHTML={{__html: soal.jawab3}}></td></tr>}
                                {soal.jawab4 !== null && <tr><td width="5">D.</td><td dangerouslySetInnerHTML={{__html: soal.jawab4}}></td></tr>}
                                {soal.jawab5 !== null && <tr><td width="5">E.</td><td dangerouslySetInnerHTML={{__html: soal.jawab5}}></td></tr>} 
                            </tbody>
                        </table>
                        {soal.tipeSoal === 'BNS' && 
                            <React.Fragment>
                                <p>Klik Benar atau Salah pada setiap pernyataan berikut !</p>
                                <table class="table table-bordered">
                                    <thead>
                                        <td>Pernyataan</td>
                                        <td width="25%">Kunci Jawaban</td>
                                    </thead>
                                    <tbody>
                                        {this.state.listDetailSoal.filter(obj => obj.idBankSoal === soal.idBankSoal).map((detail,idx) =>
                                            <tr key={idx}>
                                                <td><p>{detail.pernyataan}</p></td>
                                                <td><p>{detail.kunciJawaban === '1' ? 'Benar' : 'Salah'}</p></td>
                                            </tr>
                                        )}   
                                    </tbody>
                                </table>
                            </React.Fragment>
                        }
                        {soal.tipeSoal === 'DRAG' && 
                            <React.Fragment>
                                <table class="table table-bordered">
                                    <thead>
                                        <td width="30%" className="text-center">A</td>
                                        <td width="30%" className="text-center">B</td>
                                        <td width="40%" className="text-center">Teori</td>
                                    </thead>
                                    <tbody>
                                        {this.renderSoalDrag(soal.idBankSoal)} 
                                    </tbody>
                                </table>
                            </React.Fragment>
                        }
                        {soal.kunciJawaban !== null && <tr>Kunci Jawaban : <span dangerouslySetInnerHTML={{__html: soal.kunciJawaban}}></span></tr>}
                    </td>
                                        
                    
                </tr>    
                )}  
            </React.Fragment>
        );
    }

    

    render() {   
        const style = {
            margin: 0,
            top: 'auto',
            right: 'auto',
            bottom: 55,
            left: 'auto',
            position: 'fixed',
        };     
        return (  
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Preview Soal '} /> 
                    <Col className="text-center"><h2>{this.state.profil.namaProfil} - {this.state.subProfil.namaMapel}</h2></Col>
                    <TableContainer component={Paper}>                    
                        <table className="table">
                            <thead>
                            <tr>
                                <th width="2%">ID</th>
                                <th>Pertanyaan</th>                                
                            </tr>
                            </thead>
                            <tbody>
                                {this.renderSoal()}
                            </tbody>
                        </table>
                    </TableContainer>

                    <div>
                        <Fab style={style} onClick={() => this.handleBack()}
                        variant="extended"
                        size="small"
                        color="secondary"
                        aria-label="add"
                        ><ArrowBackIosIcon />back</Fab>                    
                    </div>

                </div>
            </div>
        );
    }

    handleBack() {       
        if(this.state.profil.kodeSubTipeCbt === 'AN') history.push({ pathname: '/akm', state: {profil: this.state.profil} });
        if(this.state.profil.kodeSubTipeCbt === 'QUEST') history.push({ pathname: '/profil_qs', state: {profil: this.state.profil} });
    }
    
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account       
    };
}

export default connect(mapStateToProps, {cekCookies})(PreviewSoal); 